<template>
  <div id="main-content" class="detail-student">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>

      <form v-if="studentInfo">
        <el-row>
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('common.full_name') }}:</span>
            <span class="info-span"> {{ studentInfo.fullname }} </span>
          </el-col>

        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('nameField.grade') }}:</span>
            <span class="info-span"> {{ studentInfo.grade?  studentInfo.grade.name : '' }} </span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline">
            <span class="form-lable">{{ $t('common.class') }}:</span>
            <span class="info-span"> {{ studentInfo.class_info ? studentInfo.class_info.name : '' }} </span>
            <span class="info-span"> </span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('common.furigana') }}:</span>
            <span class="info-span"> {{ studentInfo.furigana }} </span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline">
            <span class="form-lable">{{ $t('common.romaji') }}:</span>
            <span class="info-span"> {{ studentInfo.romaji }} </span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('common.gender') }}:</span>
            <span class="info-span" v-if="studentInfo.gender">{{ $t('common.male') }}</span>
            <span class="info-span" v-else>{{ $t('common.female') }}</span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline">
            <span class="form-lable">{{ $t('common.relation_type') }}</span>
            <span class="info-span"> {{ studentInfo.relation_parent }} </span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('common.bus_stop') }}:</span>
            <span class="info-span"> {{ studentInfo.place_info ? studentInfo.place_info.name : '' }} </span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline;">
            <span class="form-lable">{{ $t('add_parent.full_name') }}:</span>
            <span class="info-span">
              <a href="#" @click="goParent($event, studentInfo.parent_info)">
                {{ studentInfo.parent_info ? studentInfo.parent_info.name : '' }}
              </a>
            </span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="11" style="display: inline">
            <span class="form-lable">{{ $t('common.building_info') }}:</span>
            <span class="info-span"> {{ studentInfo.building_info != "null" ? studentInfo.building_info : '' }} </span>
          </el-col>
          <el-col :offset="1" :span="12" style="display: inline">
            <span class="form-lable">{{ $t('common.room_number') }}:</span>
            <span class="info-span"> {{ studentInfo.room_number != "null" ? studentInfo.room_number : '' }} </span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="11" style="display: inline" v-if="studentInfo.qrcode">
            <span class="form-lable" style="width: 40%">{{ $t('common.qr_code') }}</span>
            <img class="info-span" v-bind:src="studentInfo.qrcode" width="30%"/>
          </el-col>
          <el-col :span="11" style="display: inline" v-if="studentInfo.image">
            <span class="form-lable" style="width: 20%">{{ $t('common.image') }}</span>
            <img class="info-span" v-bind:src="studentInfo.image" width="30%"/>
          </el-col>
        </el-row>

        <el-row v-if="studentInfo.authorized_person_list" class="row-section">
          <h3 style="margin-bottom: 0; margin-top: 10px;">{{ $t('common.agent_information') }}</h3>
        </el-row>
        <el-row style="padding: 10px 20px 20px">
          <table v-if="studentInfo.authorized_person_list" class="bus-list agent-list">
            <tr>
              <th>#</th>
              <th>{{ $t('common.full_name') }}</th>
              <th>{{ $t('common.phone') }}</th>
            </tr>
            <tr v-for="(agent, k) in studentInfo.authorized_person_list" :key="agent.id">
              <td>{{ k + 1 }}</td>
              <td>{{ agent.name }}</td>
              <td>{{ agent.phone }}</td>
            </tr>
          </table>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import PageTitle from '@/components/PageTitle'

  export default {
    name: "DetailStudent",
    components: {
      PageTitle
    },
    data: function () {
      return {
        title: 'common.student_information',
        backLink: `/student?action=back`
      }
    },
    mounted: function () {
      let successCallback = () => {
      };
      let payload = {
        successCallback,
        student_id: this.$route.query.sid
      }
      this.$store.dispatch('student/getStudentInfo', payload)
    },
    computed: {
      ...mapState('student', ['studentInfo']),
    },
    methods: {
      goToEdit: function () {
        this.$router.push({path:  '/student/edit', query: { sid: this.$route.query.sid }});
      },
      goParent: function (event, parentInfo) {
        event.preventDefault()

        if (parentInfo) {
          this.$router.push({path: '/parent/detail', query: { pid: parentInfo.id }})
        }
      }
    }
  }
</script>

<style lang="scss">
  .day-in-week {
    width: 100%;
    float: left;
    text-align: left;
    font-weight: bold;
  }
  .detail-student .info-span {
    width: 40%;
    text-align: left;
  }
  .day-in-week {
    width: 100%;
    float: left;
    text-align: left;
    font-weight: bold;
  }
</style>
